import React from 'react';
import Button from './Button';

const TextButton = props => <Button variant={null} {...props} />;

export default TextButton;
